import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements, modifiers } from '../../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    display(button)
  }
})

const onKeyDown = object(listener, {
  type: keyDown,
  passive,
  task: (
    button,
    event
  ) => {
    if (event.keyCode === 13) {
      display(button)
    }
  }
})

const display = (button) => {
  const buttonSelected = one(`.${modifiers.title.focus}`, button.closest(`.${elements.list}`))
  if (null !== buttonSelected) {
    buttonSelected.classList.remove(modifiers.title.focus)
  }
  button.classList.add(modifiers.title.focus)

  const imageArea = one('[data-image-area=\'true\']', button.closest(`.${elements.container}`))
  if (null !== imageArea) {
    const clone = one(`.${elements.image}`, button.closest(`.${elements.item}`).cloneNode(true))
    replaceChildren(imageArea, clone)
  }
}

export default button => {
  onClick.listen(button)
  onKeyDown.listen(button)
}